import { KeyedMutator } from 'swr'
import useSwrImmutable from 'swr/immutable'
import { Content } from 'types/app'
import { collectionFetcher } from './useCollection'

type ReturnData = {
	isLoading: boolean
	error: string
	data: Content[][] | undefined
	refresh: KeyedMutator<Content[][]>
}

export default (links: string[]): ReturnData => {
	const { data, error, isLoading, mutate } = useSwrImmutable<Content[][]>(
		links?.length ? links : null,
		() =>
			Promise.all<Content[]>(
				links.map((url) => collectionFetcher<Content[]>(url)),
			),
	)

	return {
		data: data || [],
		isLoading,
		error,
		refresh: mutate,
	}
}
